<template lang="pug">
v-container(fluid v-if="$store.state.user && $store.state.user.role === 1")
	v-window(v-model="page" touchless)
		v-window-item
			v-data-table.mb-16(:headers="headers" :items="members" hide-default-footer disable-pagination no-results-text="查無資料" :search="search")
				template(v-slot:body="{items}")
					tbody
						tr(v-for="item,i in items" :key="i")
							td.text-left {{item.account}}
							td.text-left {{item.name}}
							td.text-left(style="white-space: pre-line;") {{(item.identity||[]).join('\n')}}
							td.text-left {{item.phone}}
							td.text-left {{item.email}}
							td.text-left {{Object.entries(item.auth).filter(x=>x[1]).map(x=>x[0]).join(',')}}
							td.text-left(style="white-space: pre-line;") {{(item.route||[]).join('\n')}}
							td.text-center
								v-layout
									v-btn(plain small @click="editing={...item, id: item.id, password: undefined};tmpInput.isEdit=true;tmpInput.identity='';tmpInput.route='';dialog=true")
										v-icon mdi-pencil
									v-btn(plain small @click="removeMember(item.account)")
										v-icon mdi-delete
			v-dialog(v-model="dialog" :max-width="600")
				v-card.pa-3
					v-layout
						v-text-field(label="帳號" v-model="editing.account" :disabled="tmpInput.isEdit")
						v-text-field(label="密碼" v-model="editing.password" type="password" placeholder="不修改請留空")
						v-text-field(label="姓名" v-model="editing.name")
					v-layout(align-center)
						v-chip(label) 身分
						v-chip(v-for="(id,i) in editing.identity" :key="i" :title="id" label close @click:close="editing.identity.splice(i,1)") {{id.slice(0,4)}}
						v-spacer
						v-select(v-model="tmpInput.identity" :items="identity")
						v-btn(small @click="addInput('identity')")
							v-icon mdi-plus
					v-layout.flex-wrap(v-if="category.includes('route')")
						v-chip(label) {{getCategoryName('route')}}
						v-chip(v-for="(e,ei) in editing.route" :key="ei" :title="e" label close @click:close="editing.route.splice(ei,1)") {{e.slice(0,4)}}
						v-layout
							v-select.mt-n3(small v-model="tmpInput.route" :items="ctable.route ? ctable.route.map(x=>x.target) : []")
							v-btn(small @click="addInput('route')")
								v-icon mdi-plus
					v-layout
						v-text-field(label="電話" v-model="editing.phone")
						v-text-field(label="信箱" v-model="editing.email")
					v-layout(align-center)
						v-checkbox(label="瀏覽問卷" v-model="editing.auth.browse")
						v-checkbox(label="管理者" v-model="editing.auth.admin")
						v-spacer
						v-btn(v-if="tmpInput.isEdit" @click="updateMember(false)") {{saving?'':'完成'}}
							v-progress-circular(v-if="saving" indeterminate)
						v-btn(v-else @click="addMember()") {{saving?'':'新增'}}
							v-progress-circular(v-if="saving" indeterminate)
		v-window-item.pa-2
			.d-flex.align-start.flex-wrap
				div
					v-chip(label).pink.white--text 類別
					v-chip(v-for="ckey in category" :key="ckey" label ) {{getCategoryName(ckey)}}
				v-spacer
				//- v-text-field(dense label="新類別" v-model="tmpInput.category")
				//- v-btn(small @click="addCategory()")
				//- 	v-icon mdi-plus
			.d-flex.align-start.flex-wrap
				v-chip(label).pink.white--text 身分
				v-chip(v-for="ikey,i in identity" :key="i" label) {{ikey}}
				v-spacer
				//- v-text-field(dense label="新身分" v-model="tmpInput.identity")
				//- v-btn(small @click="identity=identity.includes(tmpInput.identity)||tmpInput.identity==''?identity:[...identity,tmpInput.identity]")
				//- 	v-icon mdi-plus
			v-row.mt-2
				v-flex(xs12 md6 lg4 v-for="ckey in category" :key="ckey").pa-2
					v-card(style="border-radius: 10px").pa-2
						v-layout(justify-center wrap).pa-2
							v-chip.mr-1(label) {{getCategoryName(ckey)}}
							v-chip.mr-1(label)
								input(type="text" placeholder="名稱" v-model="cInput[ckey].target" style="width: 100px")
							v-chip.mr-1(label v-if="ckey === 'route'")
								input(type="number" placeholder="數量" v-model.number="cInput[ckey].total" style="width: 50px")
							v-chip(label dark v-if="cInput[ckey].isEdit" @click="updateCtable(ckey)").cyan 完成
							v-chip(label v-else @click="addCtable(ckey)") 新增
							div(style="flex-basis:100%; height:12px" v-if="ckey === 'route'")
							v-chip.mr-1(label v-if="ckey === 'route'")
								v-select(:items="businessOptions.map(name => ({ text: name, value: businessMap[name] }))" v-model="cInput[ckey].business_id" label="客運業者" dense style="width: 100px;" hide-details)
							v-chip.mr-1(label v-if="ckey === 'route'")
								v-select(:items="unitOptions.map(name => ({ text: name, value: unitMap[name] }))" v-model="cInput[ckey].unit_id" label="推動單位" dense style="width: 100px;" hide-details)
						table.table
							tr
								td {{getCategoryName(ckey)}}
								td(v-if="ckey === 'route'") 問卷總數
								td 操作
							tr(v-for="ct in ctable[ckey]" :key="ct.target")
								td {{ct.target}}
								td(v-if="ckey === 'route'") {{ct.total}}
								td
									v-btn.ma-1(plain small @click="cInput[ckey]={id: ct.id, target: ct.target, total: ckey === 'route' ? ct.total : 0, isEdit: true};$set(category,0,category[0]);").my-0
										v-icon mdi-pencil
									v-btn.ma-1(plain small @click="deleteCtable(ckey, ct)").my-0
										v-icon mdi-delete
	v-layout.psf
		v-text-field(label="搜尋" v-model="search"
			:style="{width: toggle?'200px':0, transition: '0.5s'}")
		v-btn.ma-1(@click="toggle=!toggle")
			v-icon mdi-file-find
		v-btn.ma-1(v-if="page==0" @click="page=1")
			v-icon mdi-cog
		v-btn.ma-1(v-if="page==1" @click="saveAll()")
			v-icon mdi-content-save
		v-btn.ma-1(@click="newEdit();tmpInput.isEdit=false;dialog=true")
			v-icon mdi-plus
</template>

<script>
import axios from 'axios';

export default {
	name: 'settings',
	data() {
		return {
			dialog: false,
			toggle: false,
			saving: false,
			page: 0,
			headers: [
				{ text: '帳號', value: 'account', align: 'left' },
				{ text: '姓名', value: 'name', align: 'left' },
				{ text: '身分', value: 'identity', align: 'left' },
				{ text: '電話', value: 'phone', align: 'left' },
				{ text: '信箱', value: 'email', align: 'left' },
				{ text: '權限', value: 'auth', align: 'left' },
			],
			members: [],
			search: '',
			identity: [],
			category: ['business', 'unit', 'route'],
			ctable: {
				business: [],
				unit: [],
				route: []
			},
			cInput: {
				business: { target: '', isEdit: false },
				unit: { target: '', isEdit: false },
				route: { target: '', total: 0, business_id: null, unit_id: null, isEdit: false }
			},
			editing: {
				account: '',
				password: undefined,
				name: '',
				identity: [],
				phone: '',
				email: '',
				history: [],
				auth: { admin: false, browse: false },
			},
			tmpInput: { category: '', identity: '', route: '', isEdit: false },
			businessMap: {},
			unitMap: {},
			routeMap: {},
			identityMap: {},
			identityOptions: [],
			businessOptions: [],
			unitOptions: [],  
			routeOptions: [],
		};
	},
	methods: {
		newEdit() {
			let newOne = {
				account: '',
				password: undefined,
				name: '',
				identity: [],
				phone: '',
				email: '',
				history: [],
				auth: { admin: false, browse: false },
			};
			this.category.map((key) => {
				newOne[key] = [];
			});
			this.editing = newOne;
			this.tmpInput.identity = '';
			this.tmpInput.route = '';
		},
		getCategoryName(key) {
			const categoryNameMap = {
				'business': '客運業者',
				'unit': '推動單位',
				'route': '路線',
			};
			return categoryNameMap[key] || key;
		},
		memberTypeCheck() {
			this.members = this.members.map((x) => {
				if (!x.route) {
					x.route = [];
				}
				return x;
			});
		},
		async fetchAccountList() {
			try {
				const response = await axios.get('/api/Account/AccountList');
				if (response.data.status && response.data.result) {
					this.members = response.data.result.map(account => {
						const processArray = (arr) => {
							if (!Array.isArray(arr) || arr.length === 0) return [];
							if (typeof arr[0] === 'string' && arr[0].includes(',')) {
								return arr[0].split(',').map(item => item.trim());
							}
							return arr;
						};
						
						const route = processArray(account.route || []);
						const role = account.role === '1' || account.role === 1 ? 1 : 
						             account.role === '2' || account.role === 2 ? 2 : 0;
						
						const member = {
							id: account.id || '',
							account: account.account || '',
							name: account.name || '',
							identity: Array.isArray(account.identity) ? account.identity : [],
							phone: account.phone || '',
							email: account.email || '',
							auth: {
								admin: account.role === '1',
								browse: role === 2
							}
						};
						
						member.route = route;
						
						return member;
					});
					
					this.memberTypeCheck();

					const fieldNameMap = {
						'route': '路線',
					};
					
					if (!this.headers.find(h => h.value === 'route')) {
						this.headers.push({ text: '路線', value: 'route' });
					}

					if (!this.headers.find(h => h.text === '操作')) {
						this.headers.push({ text: '操作', align: 'left' });
					}
				} else {
					this.members = [];
				}
			} catch (error) {
				this.members = [];
			}
		},
		async loadAllOptions() {
			try {
				const identityResponse = await axios.get('/api/Account/IdentityList');
				if (identityResponse.data.status && identityResponse.data.result) {
					this.identityOptions = identityResponse.data.result.map(item => item.name);
					identityResponse.data.result.forEach(item => {
						this.identityMap[item.name] = item.id;
					});
					this.identity = this.identityOptions;
				}

				const routeAndBusinessAndUnitResponse = await axios.get('/api/Account/RouteAndBusinessAndUnitList');
				if (routeAndBusinessAndUnitResponse.data.status && routeAndBusinessAndUnitResponse.data.result) {
					const result = routeAndBusinessAndUnitResponse.data.result;
					
					if (result.business) {
						this.businessOptions = result.business.map(item => item.name);
						result.business.forEach(item => {
							this.businessMap[item.name] = item.id;
						});
						this.ctable.business = result.business.map(item => ({
							id: item.id,
							target: item.name
						}));
					}
					
					if (result.unit) {
						this.unitOptions = result.unit.map(item => item.name);
						result.unit.forEach(item => {
							this.unitMap[item.name] = item.id;
						});
						this.ctable.unit = result.unit.map(item => ({
							id: item.id,
							target: item.name
						}));
					}

					if (result.routes) {
						this.routeOptions = result.routes.map(item => item.name);
						result.routes.forEach(item => {
							this.routeMap[item.name] = item.id;
						});
						this.ctable.route = result.routes.map(item => ({
							id: item.id,
							target: item.name,
							total: item.count || 0
						}));
					}
				}
			} catch (error) {
				alert('載入選項列表失敗');
			}
		},
		convertNamesToIds(names, map) {
			return names
				.map(name => map[name])
				.filter(id => id !== undefined && id !== null);
		},
		async addMember() {
			if (!this.editing.account || !this.editing.password || !this.editing.name) {
				alert('請填寫帳號、密碼和姓名');
				return;
			}
			
			this.saving = true;
			try {
				const identityIds = this.convertNamesToIds(this.editing.identity || [], this.identityMap);
				const routeIds = this.convertNamesToIds(this.editing.route || [], this.routeMap);

				let role = '0';
				if (this.editing.auth.admin) {
					role = '1';
				} else if (this.editing.auth.browse) {
					role = '2';
				}
				
				const requestData = {
					account: this.editing.account,
					password: this.editing.password,
					name: this.editing.name,
					identity: identityIds.length > 0 ? identityIds : [],
					phone: this.editing.phone || '',
					email: this.editing.email || '',
					role: role,
					route: routeIds.length > 0 ? routeIds : [],
				};
				const response = await axios.post('/api/Account/Create', requestData);
				
				if (response.data.status) {
					alert(response.data.message || '帳號建立成功！');
					await this.fetchAccountList();
					this.dialog = false;
					this.tmpInput.isEdit = false;
					this.newEdit();
					this.tmpInput.identity = '';
					this.tmpInput.route = '';
				} else {
					alert(response.data.message || '帳號建立失敗');
				}
			} catch (error) {
				alert(error.response?.data?.message || '新增帳號失敗，請稍後再試');
			} finally {
				this.saving = false;
			}
		},
		async updateMember(){
			this.saving = true;
			try {
				const identityIds = this.convertNamesToIds(this.editing.identity || [], this.identityMap).filter(id => id > 0);
				const routeIds = this.convertNamesToIds(this.editing.route || [], this.routeMap).filter(id => id > 0);

				let role = '0';
				if (this.editing.auth.admin) {
					role = '1';
				} else if (this.editing.auth.browse) {
					role = '2'; 
				}
				const requestData = {
					id: parseInt(this.editing.id),
					name: this.editing.name || '',
					phone: this.editing.phone || '',
					email: this.editing.email || '',
					role: role,
					identity: identityIds.length > 0 ? identityIds : [],
					route: routeIds.length > 0 ? routeIds : [],
				};
				
				if (this.editing.password !== undefined && 
					this.editing.password !== null &&
					this.editing.password !== '' && 
					this.editing.password !== 'string' &&
					String(this.editing.password).trim().length > 0) {
					requestData.password = this.editing.password;
				}
				
				const response = await axios.post('/api/Account/Update', requestData);
				if (response.data.status) {
					alert(response.data.message || '帳號更新成功！');
					await this.fetchAccountList();
					this.dialog = false;
					this.tmpInput.isEdit = false;
					this.newEdit();
				} else {
					alert(response.data.message || '帳號更新失敗');
				}
			} catch (error) {
				alert(error.response?.data?.message || '更新帳號失敗，請稍後再試');
			} finally {
				this.saving = false;
			}
		},
		async removeMember(account) {
			const member = this.members.find((x) => x.account == account);
			if (!member || !member.id) {
				alert('無法找到帳號 ID');
				return;
			}
			
			if (confirm('確定要刪除這個帳號嗎？')) {
				try {
					const response = await axios.post(`/api/Account/Delete?id=${member.id}`);
					
					if (response.data.status) {
						alert(response.data.message || '帳號刪除成功！');
						await this.fetchAccountList();
					} else {
						alert(response.data.message || '帳號刪除失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '刪除帳號失敗，請稍後再試');
				}
			}
		},
		addInput(key) {
			if (!this.editing[key].includes(this.tmpInput[key]) && this.tmpInput[key]) {
				this.editing[key].push(this.tmpInput[key]);
			}
		},
		addCategory() {
			if (this.tmpInput.category && !this.category.includes(this.tmpInput.category)) {
				this.members.map((x) => {
					x[this.tmpInput.category] = [];
				});
				this.editing[this.tmpInput.category] = [];
				this.ctable[this.tmpInput.category] = [];
				this.cInput[this.tmpInput.category] = { target: '', total: 0, isEdit: false };
				this.category.push(this.tmpInput.category);
				this.headers.push({ text: this.tmpInput.category, value: this.tmpInput.category });
			}
		},
		removeCategory(key) {
			this.members.map((x) => {
				delete x[key];
			});
			delete this.editing[key];
			delete this.ctable[key];
			delete this.cInput[key];
			this.category = this.category.filter((x) => x != key);
			this.headers = this.headers.filter((h) => h.value !== key);
		},
		async addCtable(ckey) {
			if (!this.ctable[ckey]) {
				this.ctable[ckey] = [];
			}

			const target = this.cInput[ckey]?.target || '';
			const total = ckey === 'route' ? (this.cInput[ckey]?.total || 0) : 0;
    		const business_id = ckey === 'route' ? (this.cInput[ckey]?.business_id || 0) : 0;
    		const unit_id = ckey === 'route' ? (this.cInput[ckey]?.unit_id || 0) : 0;
			if (this.ctable[ckey].map((x) => x.target).includes(target)) {
				alert(ckey === 'business' ? '此客運業者已存在' : ckey === 'unit' ? '此推動單位已存在' : ckey === 'route' ? '此路線已存在' : ckey + '重複了');
				return;
			}

			if (ckey === 'business') {
				try {
					const requestData = {
						name: target,
						type: 1
					};
					
					const response = await axios.post('/api/Account/createBusinessAndUnit', requestData);
					
					if (response.data.status) {
						alert(response.data.message || '客運業者建立成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, isEdit: false };
					} else {
						alert(response.data.message || '客運業者建立失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '新增客運業者失敗，請稍後再試');
				}
			} else if (ckey === 'unit') {
				try {
					const requestData = {
						name: target,
						type: 2
					};
					
					const response = await axios.post('/api/Account/createBusinessAndUnit', requestData);
					
					if (response.data.status) {
						alert(response.data.message || '推動單位建立成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, isEdit: false };
					} else {
						alert(response.data.message || '推動單位建立失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '新增推動單位失敗，請稍後再試');
				}
			}  else if (ckey === 'route') { 
				try {
					const requestData = {
						name: target,
						count: total || 0,
						business_id: business_id,
						unit_id: unit_id
					};
					
					const response = await axios.post('/api/Account/createRoute', requestData);
					
					if (response.data.status) {
						alert(response.data.message || '路線建立成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, business_id: null, unit_id: null, isEdit: false };
					} else {
						alert(response.data.message || '路線建立失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '新增路線失敗，請稍後再試');
				}
			}
		},
		async updateCtable(ckey) {
			if (!this.cInput[ckey] || !this.cInput[ckey].id) {
				alert('無法取得 ID');
				return;
			}
			
			const target = this.cInput[ckey]?.target || '';
			const total = ckey === 'route' ? (this.cInput[ckey]?.total || 0) : 0;
    		const business_id = ckey === 'route' ? (this.cInput[ckey]?.business_id || 0) : 0;
    		const unit_id = ckey === 'route' ? (this.cInput[ckey]?.unit_id || 0) : 0;
			if (ckey === 'business') {
				try {
					const requestData = {
						id: this.cInput[ckey].id,
						name: target
					};
					
					const response = await axios.post('/api/Account/updateBusinessAndUnit', requestData);
					
					if (response.data.status) {
						alert(response.data.message || '客運業者更新成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, isEdit: false };
						this.$set(this.category, 0, this.category[0]);
					} else {
						alert(response.data.message || '客運業者更新失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '更新客運業者失敗，請稍後再試');
				}
			} else if (ckey === 'unit') {
				try {
					const requestData = {
						id: this.cInput[ckey].id,
						name: target
					};
					
					const response = await axios.post('/api/Account/updateBusinessAndUnit', requestData);
					
					if (response.data.status) {
						alert(response.data.message || '推動單位更新成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, isEdit: false };
						this.$set(this.category, 0, this.category[0]);
					} else {
						alert(response.data.message || '推動單位更新失敗');
					}
				} catch (error) {
					console.error('更新推動單位失敗:', error);
					alert(error.response?.data?.message || '更新推動單位失敗，請稍後再試');
				}
			} else if (ckey === 'route') { 
				try {
					const requestData = {
						id: this.cInput[ckey].id,
						name: target,
						count: total || 0,
						business_id: business_id,
						unit_id: unit_id
					};

					const response = await axios.post('/api/Account/updateRoute', requestData);
            
					if (response.data.status) {
						alert(response.data.message || '路線更新成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, business_id: null, unit_id: null, isEdit: false };
						this.$set(this.category, 0, this.category[0]);
					} else {
						alert(response.data.message || '路線更新失敗');
					}
				} catch (error) {
					console.error('更新路線失敗:', error);
					alert(error.response?.data?.message || '更新路線失敗，請稍後再試');
				}
			}
		},
		async deleteCtable(ckey, ct) {
			if (!ct || !ct.id) {
				alert('無法取得 ID');
				return;
			}
			
			const itemName = ckey === 'business' ? '客運業者' : ckey === 'unit' ? '推動單位' : ckey === 'route' ? '路線' : '項目';
			if (ckey === 'business') {
				try {
					const response = await axios.post(`/api/Account/deleteBusinessAndUnit?id=${ct.id}`);
					
					if (response.data.status) {
						alert(response.data.message || '客運業者刪除成功！');
						await this.loadAllOptions();
					} else {
						alert(response.data.message || '客運業者刪除失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '刪除客運業者失敗，請稍後再試');
				}
			} else if (ckey === 'unit') {
				try {
					const response = await axios.post(`/api/Account/deleteBusinessAndUnit?id=${ct.id}`);
					
					if (response.data.status) {
						alert(response.data.message || '推動單位刪除成功！');
						await this.loadAllOptions();
					} else {
						alert(response.data.message || '推動單位刪除失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '刪除推動單位失敗，請稍後再試');
				}
			} else if (ckey === 'route') {
				try {
					const response = await axios.post(`/api/Account/deleteRoute?id=${ct.id}`);
						
					if (response.data.status) {
						alert(response.data.message || '路線刪除成功！');
						await this.loadAllOptions();
					} else {
						alert(response.data.message || '路線刪除失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '刪除路線失敗，請稍後再試');
				}
			}
		},
		saveAll() {
			this.page = 0;
		},
	},
	mounted() {
		this.category.forEach((key) => {
			this.editing[key] = [];
			if (!this.cInput[key]) {
				if (key === 'route') {
					this.cInput[key] = { target: '', total: 0, isEdit: false };
				} else {
					this.cInput[key] = { target: '', isEdit: false };
				}
			}
			if (!this.ctable[key]) {
				this.ctable[key] = [];
			}
		});

		this.fetchAccountList();
		this.loadAllOptions();
	},
};
</script>